import Image from "next/image";
import { useEffect } from "react";

const Scroll = () => {
  useEffect(() => {
    const first = document.querySelector("#one");
    const second = document.querySelector("#two");
    const third = document.querySelector("#three");
    const animate = (element, position) => {
      element.style.transform = `translateX(${position}px)`;
    };
    let lastKnownScrollPosition;
    document.addEventListener("scroll", function () {
      lastKnownScrollPosition = window.scrollY;
      window.requestAnimationFrame(function () {
        animate(first, lastKnownScrollPosition * 0.8);
        animate(second, lastKnownScrollPosition * -0.8);
        animate(third, lastKnownScrollPosition * 0.8);
      });
    });
  }, []);

  return (
    <>
      <div className="overflow-hidden pt-8 md:pt-24">
        <div
          className="overflow-hidden h-[30vh] md:h-[60vh] xl:h-[120vh]"
          id="container1"
        >
          <h2
            className="transition-transform duration-200 ease-linear text-5xl leading-snug md:text-8xl xl:text-[160px] font-bold text-black/5 -ml-[78rem] md:-ml-[94rem] xl:-ml-[110rem]"
            id="one"
          >
            <span className="font-jomolhari inline-block">CHALLENGES</span>
          </h2>
          <h2
            className="transition-transform duration-200 ease-linear text-5xl leading-snug md:text-8xl xl:text-[160px] font-bold text-black/5 ml-[80rem] md:ml-[132rem]"
            id="two"
          >
            <span className="font-jomolhari inline-block">ENCOUNTERED</span>
          </h2>
          <h2
            className="transition-transform duration-200 ease-linear text-5xl leading-snug md:text-8xl xl:text-[160px] font-bold text-black/5 -ml-[90rem] md:-ml-[140rem] xl:-ml-[135rem]"
            id="three"
          >
            <span className="font-jomolhari inline-block">IN THE PROJECT</span>
          </h2>
          <div className="relative bottom-64 left-0 md:bottom-72 md:left-32 xl:bottom-[22rem] xl:left-[21rem] md:[&>span]:!h-[690px] xl:[&>span]:!h-[740px]">
            <Image
              alt="Linx iOS Mobile App"
              className="w-2/5 xl:!w-full"
              src="/assets/case-study/social-networking/linx-app.webp"
              width={620}
              height={740}
              layout="fixed"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Scroll;
